import React from 'react';
import clsx from 'clsx';
import { Spinner } from 'reactstrap';

export function SpinnerContainer({ className, isLoading, children, ...props }) {
  if (isLoading)  {
    return (
      <div className={clsx("d-flex align-items-center justify-content-center", className)}>
        <Spinner {...props} />
      </div>
    )
  }

  return children
}